export type AnalysisStatus = {
  status: string
}

type AnalysisDeltaMarkdown = string
export type AnalysisResponse = AnalysisStatus | AnalysisDeltaMarkdown

export const isAnalysisStatus = (
  response: AnalysisResponse
): response is AnalysisStatus => {
  return typeof response === 'object' && 'status' in response
}
